import { Box, Typography } from "@mui/material";
import { StyledHome } from "./Home.styled";
import summer from "../../Images/summer.png";
import { ArtItemComponent } from "../../Components/ArtItem/ArtItem";
import { useArt } from "../../stores/useArt";
import { useEffect, useState } from "react";
import { Art } from "../../Models/Art";
import { useNavigate } from "react-router-dom";
import { CaretDownIcon } from "@phosphor-icons/react";


export const Home = () => {
  const {fetchAllArt} = useArt();
  const navigate = useNavigate();
  const [latestArt, setLatestArt] = useState<Art[]>([]);

  useEffect(() => {
    getLatestItems();
    // eslint-disable-next-line 
  }, []);

  const getLatestItems = async () => {
    const res = await fetchAllArt();
    if (res) setLatestArt(res.sort((a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime()).slice(0, 3))
  }

  return (
    <StyledHome>
      <Box className="header">
        <Typography variant="h1">Bijnens A.rt</Typography>
        <Box className="imageWrapper">
          <img src={summer} alt="Summer painting" />
        </Box>
        <Box className="icon">
          <CaretDownIcon size={64} weight="bold"/>
        </Box>
      </Box>
      <Box className="newest">
        <Typography variant="h2">Nieuwste Kunst</Typography>
        <Box className="artWrapper">
          {latestArt.map((artItem) => (
            <ArtItemComponent artItem={artItem} onClick={() => navigate("/gallery")} />
          ))}
        </Box>
      </Box>
    </StyledHome>
  );
};
